import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  arrowIcon: {
    transform: 'scale(0.7)',
    transition: 'transform 0.2s ease-in-out',
    cursor: 'pointer',
  },
  extended: {
    transform: 'rotate(90deg) scale(0.7) !important',
  },
  disabled: {
    opacity: 0.3,
    cursor: 'default !important',
  },
}));

export default useStyles;
